export default "__VITE_ASSET__e38562fd__"